import { classes } from "@alpacahq/ui/old";

export const Radio = ({
  id,
  label,
  value,
  isChecked,
  onClick,
}: {
  id: string;
  label: string;
  value: string;
  isChecked: boolean;
  onClick: () => void;
}) => (
  <div className="flex items-center justify-start gap-2">
    <input
      id={id}
      className={classes(
        "h-[16px] w-[16px] cursor-pointer rounded-full border bg-none bg-clip-content shadow-[inset_0_0_0_2px_#FFF]",
        isChecked
          ? "border-yellow-500 bg-yellow-400"
          : "border-cool-gray-500 bg-white",
      )}
      type="radio"
      value={value}
      defaultChecked={isChecked}
      onClick={onClick}
    />
    <label htmlFor={id} className="cursor-pointer text-base leading-5">
      {label}
    </label>
  </div>
);
